import styled from 'styled-components';

import { Link } from '@xingternal/link';
import { BodyCopy } from '@xingternal/typography';
import {
  spaceL,
  xdlColorText,
  spaceS,
  spaceM,
  xdlColorLink,
  xdlColorPricing,
  xdlColorProBusiness,
  xdlColorHoverSecondary,
  xdlColorHover,
  scale080,
  scale110,
  cornerRadiusL,
} from '@xingternal/tokens';

export const StyledList = styled.li`
  margin-bottom: ${spaceS};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledLink = styled(Link)`
  align-items: center;
  color: ${({ trackingKey }) => {
    const isPremium =
      trackingKey === 'premium' || trackingKey === 'premiumUpsellArmstrong';
    const isProJobs =
      trackingKey === 'proJobs' || trackingKey === 'proJobsUpsellArmstrong';
    const isProBusiness = trackingKey === 'proBusiness';

    if (isPremium) {
      return `${xdlColorLink}`;
    } else if (isProJobs) {
      return `${xdlColorPricing}`;
    } else if (isProBusiness) {
      return `${xdlColorProBusiness}`;
    } else {
      return `${xdlColorText}`;
    }
  }};
  cursor: pointer;
  display: flex;
  padding: ${spaceS} ${spaceL};
  position: relative;

  &,
  &:hover,
  &:focus,
  &:active {
    border-radius: ${cornerRadiusL};
    text-decoration: none;
  }

  @media (hover: hover) {
    &:hover {
      background-color: ${xdlColorHover};
    }
  }

  &:active {
    background-color: ${xdlColorHoverSecondary};
  }
`;

export const StyledCopy = styled(BodyCopy)`
  font-size: ${scale080};
  line-height: ${scale110};
  margin: 0 0 0 ${spaceM};
  text-decoration: none;

  &:last-of-type {
    margin-bottom: 0;
  }
`;
